// src/pages/FAQPage.js
import React, { useState } from 'react';
import './FAQPage.css';

const faqs = [
  {
    question: 'What services do you offer in West Yorkshire?',
    answer: 'We provide professional scaffolding installation, maintenance, and removal for residential, commercial, and industrial projects across Bradford, Leeds, Halifax, and Manchester.'
  },
  {
    question: 'Do you provide scaffolding equipment rental?',
    answer: 'Yes, we offer flexible scaffolding equipment rentals with short-term or long-term options. Contact us for pricing and availability.'
  },
  {
    question: 'How long do I keep the scaffolding for?',
    answer: 'The price covers four weeks of hire; each additional week incurs a 10% charge.'
  },
  {
    question: 'How can I request a quote?',
    answer: 'You can request a quote via our contact page, call us directly, or email us at info@bwscaffolding.co.uk. We respond quickly to all enquiries.'
  },
  {
    question: 'Do you provide scaffolding for construction sites?',
    answer: 'Yes, we supply scaffolding for all types of construction and renovation projects, including high-rise buildings and industrial worksites.'
  },
  {
    question: 'Can you work on tight deadlines?',
    answer: 'Yes, we specialise in rapid scaffolding setups and removals, ensuring your project stays on schedule.'
  },
  {
    question: 'What areas do you cover?',
    answer: 'Our services cover Bradford, Leeds, Halifax, Manchester, and the surrounding areas in West Yorkshire.'
  },
  {
    question: 'Are your scaffolds compliant with safety regulations?',
    answer: 'Yes, all our scaffolding meets UK health and safety standards and is regularly inspected for quality and compliance.'
  },
  {
    question: 'Do you offer emergency scaffolding services?',
    answer: 'Yes, we provide emergency scaffolding solutions for urgent repairs or unexpected construction requirements.'
  },
  {
    question: 'Can you provide scaffolding for events?',
    answer: 'Yes, we can supply temporary scaffolding structures for events, staging, and outdoor installations.'
  },
  {
    question: 'What is the minimun price for a scaffold?',
    answer: 'Our set minimun price for a scaffold is 180 GBP.'
  },
  {
    question: 'How experienced is your team?',
    answer: 'Our team has over 2 decades of scaffolding experience in West Yorkshire, handling projects of all sizes with professionalism and safety.'
  },
  {
    question: 'What makes B&W Scaffolding different?',
    answer: 'We combine premium service, safety compliance, and local expertise to deliver reliable scaffolding solutions across West Yorkshire. Our family has also been scaffolding for multiple generations.'
  }
];

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <header className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p>Clear answers to the questions we hear most from our clients in West Yorkshire.</p>
      </header>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            className={`faq-card ${activeIndex === index ? 'active' : ''}`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question-row">
              <h3>{faq.question}</h3>
              <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
            </div>

            <div className="faq-answer-wrapper">
              <p className="faq-answer">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;